import { render } from "./RequestFormWrapper.vue?vue&type=template&id=651db567&ts=true&lang=pug"
import script from "./RequestFormWrapper.vue?vue&type=script&setup=true&lang=ts"
export * from "./RequestFormWrapper.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__